import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import MatchHydrate from './match-hydrate.js';
import DepositWithdraw from './deposit-withdraw.js';
import DepositBonus from './deposit-bonus.js';
import DepositBonusNP from './deposit-bonus-np.js';
import DepositPayment from './deposit-payment.js';
import DepositPaymentNB from './deposit-payment-nb.js';
import DepositPaymentNP from './deposit-payment-np.js';
import DepositPaymentNPNB from './deposit-payment-npnb.js';
import DepositShopPayment from './deposit-shop-payment.js';
import navDeposit from './../payment/navdeposit/index.js';
import { lastProduct } from './../store/cookies.js';
import login from './../login.js';
import Cookies from './../libs/tomcat-cookies.js';
import { fetchJson } from '../core/ajax-json.js';

class Deposit extends Component {
	componentWillMount() {
		fetchJson('/player/balance').then((resultData) => {
			Cookies.set('lastBalance', resultData.result.amount);
		});

		if (!lastProduct()) {
			login.getDefaultPath(() => {
				return;
			});
		}
	}

	componentWillUnmount() {
		navDeposit.close();
	}

	render() {
		return (
			<div id="deposit">
				<Switch>
					<MatchHydrate authenticate path="/account/deposit/withdraw" component={DepositWithdraw} />
					<MatchHydrate authenticate path="/account/deposit/bonus" component={DepositBonus} />
					<MatchHydrate authenticate path="/account/deposit/bonusnp" component={DepositBonusNP} />
					<MatchHydrate authenticate path="/account/deposit/payment" component={DepositPayment} />
					<MatchHydrate authenticate path="/account/deposit/paymentnb" component={DepositPaymentNB} />
					<MatchHydrate authenticate path="/account/deposit/paymentnp" component={DepositPaymentNP} />
					<MatchHydrate authenticate path="/account/deposit/paymentnpnb" component={DepositPaymentNPNB} />
					<MatchHydrate authenticate path="/account/deposit/shoppayment" component={DepositShopPayment} />
					<Route render={() => <Redirect to="/account/deposit/withdraw" />} />
				</Switch>
			</div>
		);
	}
}

export default Deposit;



// WEBPACK FOOTER //
// ./mobile-core/src/components/deposit.js